import {CxEvent} from "@spartacus/core";
import {ElementRef} from "@angular/core";
import {GonvarriProduct} from "../models/gonvarri-product.model";

export class GonvarriCartUiEventAddToCart extends CxEvent {

  static override readonly type = "CartUiEventAddToCart";
  product: GonvarriProduct = {} as GonvarriProduct;
  quantity: number = 0;
  numberOfEntriesBeforeAdd: number = 0;
  pickupStoreName?: string;
  lenght?: string;
  weight?: string;
  disableInputs?: boolean;
  width?: string;
  thickness?: string;
  packProductRowMaxStockQuantity?: number;

  triggerElementRef?: ElementRef;
}
